import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TopBarService {

  @Output() topBarParameter = new EventEmitter();

  constructor() { }

  sendTopBarParameter(parameter: string): void {
    this.topBarParameter.emit(parameter);
  }
}
